import { PRECHAT_MESSAGE_FIELD_ID, SDK } from 'sdk';
import { PERSONAL_AGREEMENT_FIELD_ID } from 'sdk';

type ReturnType = { messageError: string; personalAgreementError: string };

export const useFormErrors = (rootStore: SDK): ReturnType => ({
	messageError: rootStore.formsStore.openingFormErrors[PRECHAT_MESSAGE_FIELD_ID],
	personalAgreementError: rootStore.formsStore.openingFormErrors[PERSONAL_AGREEMENT_FIELD_ID],
});
